const { FUSION_SERVER_TAG, FUSION_AI_TAG, APP_STUDIO_TAG } = require('config/productItems')

function getFacetedQueryParamValuesString(param){
  const [match, queryParamName, valuesString, after] = param.match(/(.*)\((.*)\)(.*)/) // eslint-disable-line no-unused-vars
  return valuesString;
};

function hasProductFromString(main, check){
  if(!main) return false
  if(main.split(', ').includes(check)){
    return true
  }
  if(check === FUSION_SERVER_TAG && (main.includes(FUSION_AI_TAG) || main.includes(APP_STUDIO_TAG))){
    return true
  }
  return false;
}

// helper function for getRemainingFacets to remove facet from query params
function removeFacets(facetedQueryParams, facetName){
  const foundFacetIndex = facetedQueryParams.findIndex(item => item.includes(facetName))
  if(foundFacetIndex >= 0){
    facetedQueryParams.splice(foundFacetIndex, 1)
  }
}

// removes facets from query params
function getRemainingFacets(name, facetedQueryParams){
  removeFacets(facetedQueryParams, name)
  if(name === "productName"){
    removeFacets(facetedQueryParams, "productVersion")
    removeFacets(facetedQueryParams, "objective")
    removeFacets(facetedQueryParams, "persona")
    removeFacets(facetedQueryParams, "appType")
  }
  return(facetedQueryParams)
}

module.exports = {
  getFacetedQueryParamValuesString,
  hasProductFromString,
  getRemainingFacets
};
